export { ElearningHomeHero } from "./hero";
export { ElearningHomeHero2 } from "./hero2";
export { ElearningHomeCount } from "./count";
export { ElearningHomeIntro } from "./intro";
export { ElearningDemoBooking } from "./demo_booking";
export { ElearningDemoFree } from "./demo_free";
export { ElearningTechnologySuccess } from "./technology_success";
export { ElearningHomeOnlineTest } from "./online_test";
export { ElearningHomeSteps } from "./steps";
export { ElearningHomeStats } from "./stats";
